module.exports = __webpack_public_path__ + "static/media/clip-middle-img.051a0118.jpg";